import { dataGirl } from 'dls-icons-data'
import { createIcon } from '../common'

const IconGirl = /*#__PURE__*/createIcon(dataGirl)
export default IconGirl
